import React from 'react';
import { UseFieldApiProps } from '@data-driven-forms/react-form-renderer';
import clsx from 'clsx';

export function FieldError({
  error,
  isError,
  name,
  errorClassName
}: {
  error: UseFieldApiProps<unknown>['meta']['error'];
  isError?: boolean;
  name?: string;
  errorClassName?: string;
}) {
  return (
    <p
      className={clsx(isError && 'h-4 mt-1 mb-0 text-xs text-red-500 whitespace-no-wrap', errorClassName)}
      id={name && `error-for-${name}`}
      aria-live='assertive'
      data-testid='error-field'
    >
      {isError && error}
    </p>
  );
}
